// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f52b6c4f","952":"11a45150"}[chunkId] + ".chunk.js";
};